import React, { ReactNode } from 'react';
import styles from './DENTModalOverviewButtonsSelection.module.scss';
import DENTModalOverviewHeader from '../DENTModalOverviewHeader/DENTModalOverviewHeader';

interface Props {
	title: string;
	onClose: () => void;
	children: ReactNode;
}

const DENTModalOverviewButtonsSelection = ({
	title,
	onClose,
	children,
}: Props) => {
	return (
		<div className={styles.container}>
			<DENTModalOverviewHeader title={title} onClose={onClose} />
			{children}
		</div>
	);
};

export default DENTModalOverviewButtonsSelection;
